import { useTranslation } from 'react-i18next'

import { useUserProfileContext } from '../../User'
import {
  ProfileActionsWidget,
  useIsProfileWidgetsExpandAvailable,
} from '../../Widget'

import { useUserProfilePageActionsWidgetHandlers } from './UserProfilePageActionsWidget.hooks'
import { getUserProfilePageActionsWidgetItems } from './UserProfilePageActionsWidget.utils'

import * as styles from './UserProfilePageActionsWidget.module.css'

function UserProfilePageActionsWidget({
  className = styles.UserProfilePageActionsWidget,
  getActionList,
  getAddNewOptions,
}) {
  const { t } = useTranslation()

  const { isInitiated, userData } = useUserProfileContext()

  const isWidgetsExpandAvailable = useIsProfileWidgetsExpandAvailable()

  const {
    addNewOptions,
    getUploadFileInputProps,
    handleClickAction,
    handleSelectAddNewOption,
  } = useUserProfilePageActionsWidgetHandlers({ getAddNewOptions })

  const actions = getUserProfilePageActionsWidgetItems({
    addNewOptions,
    getActionList,
    t,
    userData,
    onSelectAddNewOption: handleSelectAddNewOption,
  })

  const hasActions =
    !isInitiated || actions.length > 0 || isWidgetsExpandAvailable

  return hasActions ? (
    <>
      <ProfileActionsWidget
        actions={actions}
        className={className}
        isSkeleton={!isInitiated}
        onClickAction={handleClickAction}
      />
      <input {...getUploadFileInputProps()} />
    </>
  ) : null
}

export default UserProfilePageActionsWidget
